import type { Dayjs } from 'dayjs';
import type { CreateSetupInvestorRequest } from '@/store/clientsApi';
import { AdvisorInvestorSetupUpdate } from '@/store/usersApi';

export type ClientFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  ssn: string;
  dob: Dayjs | null;
  stateCode: string;
  gender: number | string;
  maritalStatus: number | string;
  tdAceUserId: string;
  externalId: string;
};

export const buildEditInvestorPayload = (
  values: ClientFormValues,
): AdvisorInvestorSetupUpdate => ({
  FirstName: values.firstName,
  LastName: values.lastName || null,
  UserName: values.email,
  SocialSecurityNumber: values.ssn || null,
  // Legacy parity with existing API: DOB is a string in M/D/YYYY format
  DOB: values.dob ? values.dob.format('M/D/YYYY') : null,
  State: values.stateCode || null,
  Gender: Number(values.gender) || null,
  MaritalStatus: Number(values.maritalStatus) || null,
  TDAceUserId: values.tdAceUserId === '' ? null : values.tdAceUserId,
  ExternalId: values.externalId === '' ? null : values.externalId,
  Name: [values.firstName, values.lastName].filter(Boolean).join(' '),
});

/**
 * Maps the shared client form values into the create-investor API request.
 * Views that create a client can reuse this; edit views build their own payload.
 */
export const buildCreateInvestorPayload = (
  values: ClientFormValues,
  { isProspect = false }: { isProspect?: boolean } = {},
): CreateSetupInvestorRequest => ({
  FirstName: values.firstName,
  LastName: values.lastName || null,
  UserName: values.email,
  SocialSecurityNumber: values.ssn || null,
  // Legacy parity with existing API: DOB is a string in M/D/YYYY format
  DOB: values.dob ? values.dob.format('M/D/YYYY') : null,
  State: values.stateCode || null,
  Gender: Number(values.gender) || null,
  MaritalStatus: Number(values.maritalStatus) || null,
  TDAceUserId: values.tdAceUserId === '' ? null : values.tdAceUserId,
  ExternalId: values.externalId === '' ? null : values.externalId,
  Name: [values.firstName, values.lastName].filter(Boolean).join(' '),
  ...(isProspect ? { IsProspect: true } : {}),
});
